import { Container, Sprite, Text, TextStyle } from "pixi.js";
import { GameFont } from "../../../common/GameFont";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";

export class GetRewardContainer extends Container {
    private greenRewardText: Text;
    private additionalText: Text;
    private rewardIcon: Sprite;
    public constructor(commonResources: CommonResourcesPackage, rewardValue: number) {
        super();
        const text = new Text(`GET REWARD`, new ContainerTextStyle());
        this.addChild(text);
        this.additionalText = new Text(`OF`, new ContainerTextStyle());
        this.additionalText.position.set(9, 31.5);
        this.addChild(this.additionalText);
        this.greenRewardText = new Text(`${rewardValue}`, new ContainerTextStyle());
        this.greenRewardText.style.fill = "#00ff29";
        this.greenRewardText.position.set(39.5, 31.5);
        this.addChild(this.greenRewardText);
        this.rewardIcon = new Sprite(commonResources.assets_common_ui_button_token_icon_png);
        this.rewardIcon.width = 24;
        this.rewardIcon.height = 24;
        this.rewardIcon.position.set(this.greenRewardText.x + this.greenRewardText.width + 2, 33);
        this.addChild(this.rewardIcon);
    }

    public setGreenRewardText(value: string) {
        this.greenRewardText.text = value;
        const sizeX = this.additionalText.width + this.greenRewardText.width + this.rewardIcon.width;
        this.additionalText.position.x = this.width * 0.5 - sizeX * 0.5;
        this.greenRewardText.position.x = this.additionalText.x + this.additionalText.width + 5;
        this.rewardIcon.position.set(this.greenRewardText.x + this.greenRewardText.width + 5, 33);
    }
}

class ContainerTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 32
        }));
    }
}